import { Component, Input, Renderer2, ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ConfigService } from 'src/providers/config/config.service';
import { Network } from '@ionic-native/network/ngx';
import { Geolocation, GeolocationOptions, Geoposition, PositionError } from '@ionic-native/geolocation/ngx';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';



declare var google;

@Component({
    selector: 'google-map',
    templateUrl: './google-maps.component.html',
    styleUrls: ['./google-maps.component.scss'],
})

export class GoogleMapComponent {

    public map: any;

    public poly: any;
    private options: GeolocationOptions;
    public marker: any;
    public position = { latitud: 0, longitud: 0 };
    public markers: any[] = [];
    private mapsLoaded: boolean = false;

    constructor(private renderer: Renderer2,
        private element: ElementRef,
        @Inject(DOCUMENT) private _document,
        private config: ConfigService,
        private network: Network,
        private geolocation: Geolocation,
        private shared: SharedDataService) {
    }

    ngOnInit() {

        this.init().then((res) => {
            console.log("Google Maps en linea.")
        }, (err) => {
            console.log(err);
        });

    }

    private init(): Promise<any> {

        return new Promise((resolve, reject) => {

            this.loadSDK().then((res) => {

                this.initMap().then((res) => {
                    resolve(true);
                }, (err) => {
                    reject(err);
                });

            }, (err) => {

                reject(err);

            });

        });

    }


    private loadSDK(): Promise<any> {

        console.log("Cargando Google Maps SDK");

        return new Promise((resolve, reject) => {

            if (!this.mapsLoaded) {


                //     let connectSubscription = this.network.onConnect().subscribe(() => {
                console.log('network connected!');

                this.injectSDK().then((res) => {
                    resolve(true);
                }, (err) => {
                    reject(err);
                });

                //     });

                // stop connect watch
                //     connectSubscription.unsubscribe();
            } else {
                reject('SDK already loaded');
            }
        });
    }

    public injectSDK(): Promise<any> {

        return new Promise((resolve, reject) => {


            window['mapInit'] = () => {
                this.mapsLoaded = true;
                resolve(true);
            }

            console.log(this.config.appSettings['google_map_api']);

            let script = this.renderer.createElement('script');
            script.id = 'googleMaps';
            console.log(this.config.appSettings['google_map_api']);
            if (this.config.appSettings['google_map_api']) {
                script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.config.appSettings['google_map_api'] + '&v3&callback=mapInit';
            } else {
                script.src = 'https://maps.googleapis.com/maps/api/js?callback=mapInit';
            }

            this.renderer.appendChild(this._document.body, script);

        });

    }

    private initMap(): Promise<any> {

        return new Promise((resolve, reject) => {

            this.geolocation.getCurrentPosition(this.options).then((pos: Geoposition) => {
                this.position.longitud = pos.coords.longitude;
                this.position.latitud = pos.coords.latitude;
                let latLng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);

                let mapOptions = {
                    center: latLng,
                    zoom: 15
                };

                this.map = new google.maps.Map(this.element.nativeElement, mapOptions);

                resolve(true);

            }, (err: PositionError) => {
                console.log("error : " + err.message);

                let branch = this.shared.allBranchOffice[0];

                let latLng = new google.maps.LatLng(parseFloat(branch.latitud), parseFloat(branch.longitud));

                let mapOptions = {
                    center: latLng,
                    zoom: 15
                };

                this.map = new google.maps.Map(this.element.nativeElement, mapOptions);


            });

        });

    }

    public addMarker(lat: number, lng: number, title): void {

        let latLng = new google.maps.LatLng(lat, lng);

        let marker = new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: latLng,
            draggable: false,
            title: title
        });

        this.markers.push(marker);

    }

    public addMarker_infoWin(lat: number, lng: number, title, content): void {

        let latLng = new google.maps.LatLng(lat, lng);

        let marker = new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: latLng,
            draggable: false,
            title: title
        });

        this.addInfoWindow(marker, content);
        this.markers.push(marker);
    }


    public addMarker_x(latLng, title): void {

        let marker = new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: latLng,
            draggable: false,
            title: title
        });

        this.markers.push(marker);

    }

    public setMapOnAll() {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(this.map);
        }
    }

    public setMapNull() {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
    }

    // Removes the markers from the map, but keeps them in the array.
    public clearMarkers() {
        this.setMapNull();
    }

    // Shows any markers currently in the array.
    public showMarkers() {
        this.setMapOnAll();
    }

    // Deletes all markers in the array by removing references to them.
    public deleteMarkers() {
        this.clearMarkers();
        this.markers = [];
    }

    public trazarRuta(geos: any) {
        let ruta = [];
        this.deleteMarkers();

        geos.forEach(geo => {
            ruta.push(new google.maps.LatLng(geo.latitud, geo.longitud));
            //      this.addMarker(geo.latitud, geo.longitud,  geo.fecha);
        });

        let inicio = ruta[0];
        let fin = ruta[ruta.length - 1];


        this.addMarker_x(inicio, 'Inicio: ' + inicio.fecha);
        this.addMarker_x(fin, 'Fin' + fin.fecha);


        if (this.poly) {
            this.poly.setMap(null);
        }


        /*    let dsConf = {
                origin: inicio,
                destination: fin,
                travelMode: google.maps.TravelMode.DRIVING
            }
       
       
            let dService = new google.maps.DirectionsService;
            let directionsDisplay = new google.maps.DirectionsRenderer;
            directionsDisplay.setMap(this.map);  
            dService.route(dsConf, function (response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);
    
                }
            });
     
           */
    }

    public trazar(a, b) {


        let inicio = new google.maps.LatLng(a.latitud, a.longitud);
        let fin = new google.maps.LatLng(b.latitud, b.longitud)


        let dsConf = {
            origin: inicio,
            destination: fin,
            travelMode: google.maps.TravelMode.DRIVING
        }
        let dService = new google.maps.DirectionsService;
        let directionsDisplay = new google.maps.DirectionsRenderer;

        directionsDisplay.setMap(this.map);
        dService.route(dsConf, function (response, status) {
            if (status == google.maps.DirectionsStatus.OK) {
                directionsDisplay.setDirections(response);

            }
        });

    }

    public autoCenter() {
        //  Create a new viewpoint bound
        let bounds = new google.maps.LatLngBounds();
        //  Go through each...
        this.markers.forEach(mark => {
            bounds.extend(mark.position);
        });
        //  Fit these bounds to the map
        this.map.fitBounds(bounds);
    }

    public addInfoWindow(marker, content) {
        let infoWindow = new google.maps.InfoWindow({
            content: content
        });
        google.maps.event.addListener(marker, 'click', () => {
            console.log('click');
            infoWindow.open(this.map, marker);

        });
    }



    public addMarker_actual(lat: number, lng: number, title): void {
        let latLng = new google.maps.LatLng(lat, lng);
        let marker = new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: latLng,
            draggable: false,
            title: title,
            icon: {
                path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                scale: 5,
                strokeWeight: 2,
                strokeColor: "#B40404"
            }
        });
        this.markers.push(marker);
    }


    public addMarker_drag(lat: number, lng: number, title): void {
        let latLng = new google.maps.LatLng(lat, lng);

        this.marker = new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: latLng,
            draggable: true,
            title: title
        });

        google.maps.event.addListener(this.marker, 'dragend', (event) => {
            this.position.latitud = event.latLng.lat();
            this.position.longitud = event.latLng.lng();
            // console.log(this.position);

        });

        this.position.latitud = lat;
        this.position.longitud = lng;
        this.markers.push(this.marker);
    }

    public getPosition() {
        return this.position;
    }


    calcularDistancia(origen, destino) {
        let service = new google.maps.DistanceMatrixService;
        let resultado = { distancia: 0, tiempo: { duracion: 0, text: '' } };
        service.getDistanceMatrix({
            origins: [origen],
            destinations: [destino],
            travelMode: 'DRIVING',
            unitSystem: google.maps.UnitSystem.METRIC,
            avoidHighways: false,
            avoidTolls: false
        }, (response, status) => {
            if (status == 'OK') {
                resultado.distancia = response['rows'][0]['elements'][0]['distance']['value'];
                resultado.tiempo = response['rows'][0]['elements'][0]['duration'];
                return resultado;
            } else {
                return resultado;
            }
        });
        return resultado;
    }

    

}

